import { QueryOptions, FetchPolicy } from 'apollo-client';
import { StockPriceQueryVariables } from './__generated__/StockPriceQuery';
import * as query from './query.gql';

export const stockPriceQuery = (
  variables: StockPriceQueryVariables,
  fetchPolicy: FetchPolicy = 'cache-first'
): QueryOptions<StockPriceQueryVariables> => ({
  query,
  variables,
  fetchPolicy,
});
